// Truncate to maxLength preferring full sentences, then word boundaries. No ellipsis.
export function truncateForMeta(input, maxLength = 160, locale = "sv") {
  if (input == null) return input;

  let text = String(input)
    // Strip simple HTML tags
    .replace(/<[^>]+>/g, " ")
    // Normalize whitespace and newlines
    .replace(/(\r\n|\n|\r)/gm, " ")
    .replace(/\s+/g, " ")
    .trim();

  if (text.length <= maxLength) return text;

  const MIN_SENTENCE_LENGTH = Math.min(
    120,
    Math.max(80, Math.floor(maxLength * 0.6))
  );

  // Try sentence boundary via Intl.Segmenter
  try {
    if (typeof Intl !== "undefined" && typeof Intl.Segmenter === "function") {
      const seg = new Intl.Segmenter(locale, { granularity: "sentence" });
      let acc = "";
      for (const { segment } of seg.segment(text)) {
        if ((acc + segment).length > maxLength) break;
        acc += segment;
      }
      const trimmedAcc = acc.trim();
      if (trimmedAcc.length >= MIN_SENTENCE_LENGTH) {
        return tidyEnding(trimmedAcc);
      }
    }
  } catch {
    // ignore
  }

  // Regex-based sentence boundary within limit
  const windowText = text.slice(0, maxLength);
  const sentenceBoundary = /[.!?](?:\s|$)/g;
  let lastSentenceCut = -1;
  let m;
  while ((m = sentenceBoundary.exec(windowText)) !== null) {
    lastSentenceCut = m.index + 1; // include punctuation
  }
  if (lastSentenceCut >= MIN_SENTENCE_LENGTH) {
    return tidyEnding(windowText.slice(0, lastSentenceCut).trim());
  }

  // Fallback to word boundary (last whitespace)
  const lastSpace = windowText.lastIndexOf(" ");
  if (lastSpace > 0) {
    return tidyEnding(windowText.slice(0, lastSpace).trim());
  }

  // Final hard cut
  return tidyEnding(windowText.trim());

  function tidyEnding(s) {
    // Remove trailing commas/semicolons/colons/dashes/spaces
    return s.replace(/[,\u2013\u2014;: -]+$/u, "").trim();
  }
}
